module.exports = __webpack_public_path__ + "static/media/loading.2e9af139.gif";